import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M97-113q-13 0-21-5-9-6-14-15-5-8-6-19 0-10 6-21l384-662q6-10 15-15t19-5q10 0 19 5t15 15l384 662q6 11 6 21-1 11-6 19-5 9-14 15-8 5-21 5H97Zm58-73h650L480-748 155-186Zm329-52q13 0 23-10 9-9 9-23t-9-22q-10-9-23-9t-23 9q-9 10-9 23t9 22q10 10 23 10Zm0-110q13 0 22-9 8-8 8-21v-159q0-13-9-22-8-8-21-8t-22 8q-8 9-8 22v159q0 13 9 21 8 9 21 9Zm-4-119Z"/>',
  f: '<path d="M97-113q-13 0-21-5-9-6-14-15-5-8-6-19 0-10 6-21l384-662q6-10 15-15t19-5q10 0 19 5t15 15l384 662q6 11 6 21-1 11-6 19-5 9-14 15-8 5-21 5H97Zm387-125q13 0 23-10 9-9 9-23t-9-22q-10-9-23-9t-23 9q-9 10-9 23t9 22q10 10 23 10Zm0-110q13 0 22-9 8-8 8-21v-159q0-13-9-22-8-8-21-8t-22 8q-8 9-8 22v159q0 13 9 21 8 9 21 9Z"/>',
};

export default data;
